import { Reducer } from 'redux';
import { Custodian, FoundCustodian } from 'types';
import { RootReducerType } from './index';
import { Actions } from 'store/actions/favouriteCustodians.action';
import {
  FETCH_CUSTODIANS_REQUEST,
  FETCH_CUSTODIANS_SUCCESS,
  FETCH_CUSTODIANS_FAILURE,
  UPDATE_CUSTODIANS_REQUEST,
  UPDATE_CUSTODIANS_FAILURE,
  ADD_NEW_CUSTODIAN,
  DELETE_CUSTODIAN,
  SEARCH_CUSTODIANS_FAILURE,
  SEARCH_CUSTODIANS_SUCCESS,
  SEARCH_CUSTODIANS_REQUEST,
  ADD_CUSTODIAN_DATA,
  CUSTODIAN_DETAILS_LOADING,
  CUSTODIAN_DETAILS_FAILURE
} from 'store/types/favouriteCustodians';

export type State = {
  custodians: Custodian[];
  foundCastodians: FoundCustodian[];
  isSearching: boolean;
  isFetching: boolean;
  isUpdating: boolean;
  error: string;
  isDetailsLoading: boolean;
};

const initialState: State = {
  custodians: [],
  foundCastodians: [],
  isSearching: false,
  isFetching: false,
  isUpdating: false,
  error: '',
  isDetailsLoading: false
};

export const custodiansReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTODIANS_REQUEST:
      return { ...state, isFetching: true };
    case FETCH_CUSTODIANS_SUCCESS:
      return { ...state, custodians: [...action.preload], isFetching: false };
    case FETCH_CUSTODIANS_FAILURE:
      return { ...state, isFetching: false, error: action.error };
    case UPDATE_CUSTODIANS_REQUEST:
      return { ...state, isUpdating: true };
    case UPDATE_CUSTODIANS_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    case ADD_NEW_CUSTODIAN:
      return { ...state, custodians: [...state.custodians, action.preload], isUpdating: false };
    case DELETE_CUSTODIAN:
      return { ...state, custodians: state.custodians.filter(item => item.id !== action.id), isUpdating: false };
    case SEARCH_CUSTODIANS_REQUEST:
      return { ...state, isSearching: true };
    case SEARCH_CUSTODIANS_SUCCESS:
      return { ...state, foundCastodians: action.add ? state.foundCastodians.concat(action.preload) : action.preload, isSearching: false };
    case SEARCH_CUSTODIANS_FAILURE:
      return { ...state, error: action.error, isSearching: false };

    case CUSTODIAN_DETAILS_LOADING:
      return { ...state, isDetailsLoading: true }
    case CUSTODIAN_DETAILS_FAILURE:
      return { ...state, isDetailsLoading: false, error: action.error }
    case ADD_CUSTODIAN_DATA: {
      if (!state.foundCastodians.some(custodian => custodian.id == action.preload.id)) return { ...state, foundCastodians: state.foundCastodians.concat(action.preload), isDetailsLoading: false }
      else return { ...state, isDetailsLoading: false }
    }
      
    default:
      return state;
  }
};

export default custodiansReducer;
export const custodiansSelector = (state: RootReducerType) => state.favouriteCustodians;
